import { COLORS } from 'helpers/globals'

export default class extends google.maps.OverlayView {
  constructor({ map, visible, ignoreClick }) {
    super()
    this.visible = visible
    this.position = null
    this.ignoreClick = ignoreClick
    this.setMap(map)
  }

  onAdd() {
    const bubble = document.createElement('div')
    bubble.textContent = 'Camera already cabled'
    bubble.style.position = 'absolute'
    bubble.style.top = 0
    bubble.style.left = 0
    bubble.style.transform = 'translate(-50%, calc(-100% - 18px))'
    bubble.style.background = COLORS.danger
    bubble.style.color = 'white'
    bubble.style.padding = '0.5rem'
    bubble.style.borderRadius = '0.5rem'
    bubble.style.boxShadow = '0px 2px 10px 1px rgba(0, 0, 0, 0.5)'
    this.bubble = bubble

    const bubbleArrow = document.createElement('div')
    bubbleArrow.style.position = 'absolute'
    bubbleArrow.style.top = 0
    bubbleArrow.style.left = 0
    bubbleArrow.style.transform = 'translate(-50%, -18px)'
    bubbleArrow.style.width = 0
    bubbleArrow.style.height = 0
    bubbleArrow.style.borderRight = '6px solid transparent'
    bubbleArrow.style.borderLeft = '6px solid transparent'
    bubbleArrow.style.borderTop = `8px solid ${COLORS.danger}`

    this.containerDiv = document.createElement('div')
    this.containerDiv.appendChild(bubble)
    this.containerDiv.appendChild(bubbleArrow)
    this.containerDiv.style.position = 'absolute'
    this.containerDiv.style.width = '100%'
    this.containerDiv.style.cursor = 'not-allowed'
    this.setVisibility(this.visible)

    this.containerDiv.addEventListener('mousedown', this.ignoreClick, true)

    this.getPanes().floatPane.appendChild(this.containerDiv)
  }

  setVisibility(visible) {
    if (visible) {
      this.containerDiv.style.visibility = 'visible'
      this.containerDiv.style.setProperty('opacity', 1, 'important')
      this.containerDiv.style.transition = 'visibility 0s linear 0s, opacity 200ms'
    } else {
      this.containerDiv.style.visibility = 'hidden'
      this.containerDiv.style.setProperty('opacity', 0, 'important')
      this.containerDiv.style.transition = 'visibility 0s linear 200ms, opacity 200ms'
    }
  }

  setPosition(position, text) {
    if (!this.containerDiv) return

    this.position = position
    this.visible = true
    this.bubble.textContent = text
    this.draw()
  }

  setVisible(visible) {
    if (!this.containerDiv) return

    this.visible = visible
    this.setVisibility(visible)
  }

  getVisible() {
    return this.visible
  }

  draw() {
    const { containerDiv, position } = this

    if (!this.visible) return

    const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)
    const display = Math.abs(divPosition.x) < 5000 && Math.abs(divPosition.y) < 5000

    if (display) {
      containerDiv.style.left = divPosition.x + 'px'
      containerDiv.style.top = divPosition.y + 'px'
    }

    this.setVisibility(display)
  }

  onRemove() {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv)
    }
    this.containerDiv.removeEventListener('mousedown', this.ignoreClick, true)
    this.containerDiv = null
  }
}



// WEBPACK FOOTER //
// ./src/components/ConnectedWiringWarning/index.js